document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.js-newsletter-popup');
  if (!popup) return;

  const closeBtns = popup.querySelectorAll('.js-newsletter-popup-close');
  const delay = 4000; // 4 seconds
  const storageKey = 'newsletterPopupSeen';

  // Open popup
  function openPopup() {
    popup.classList.add('is-active');
  }

  // Close popup
  function closePopup() {
    popup.classList.remove('is-active');
    localStorage.setItem(storageKey, 'true');
  }

  // Show only once
  if (!localStorage.getItem(storageKey)) {
    setTimeout(openPopup, delay);
  }

  closeBtns.forEach(btn => {
    btn.addEventListener('click', closePopup);
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closePopup();
    }
  });
});
